(function () {
  // Valori bottom quando sticky bar è NASCOSTA
  var LAUNCHER_DEFAULT = 70;
  var CONVERSATION_DEFAULT = 145;

  // Valori bottom quando sticky bar è VISIBILE
  var LAUNCHER_STICKY = 130;
  var CONVERSATION_STICKY = 205;

  // Mobile: valori specifici
  var LAUNCHER_MOBILE_DEFAULT = 70;
  var LAUNCHER_MOBILE_STICKY = 117;
  var CONVERSATION_MOBILE = 0;

  // Onetrust Mobile Btn Offset: aggiungere se necessario posizionarlo più in alto
  // per allinearlo alla stessa altezza del btn di Genesys
  var ONETRUST_BTN_BOTTOM_OFFSET = 12;

  function isMobile() {
    return window.innerWidth < 680;
  }

  function getStickyBar() {
    // Su mobile usa #stickyAddToCart, su desktop usa #stickyAddToCartDesktop
    if (isMobile()) {
      return document.getElementById('stickyAddToCart');
    }
    return document.getElementById('stickyAddToCartDesktop');
  }

  function isStickyBarVisible() {
    var stickyBar = getStickyBar();
    if (!stickyBar) return false;
    
    // Controlla se è nascosta con tw-hidden (vecchio metodo)
    if (stickyBar.classList.contains('tw-hidden')) return false;
    
    // Controlla se display è none
    var computedStyle = window.getComputedStyle(stickyBar);
    if (computedStyle.display === 'none') return false;
    
    // Controlla se è nascosta con opacity (nuovo metodo fade)
    var opacity = parseFloat(computedStyle.opacity);
    if (opacity < 0.5) return false;

    return true;
  }

  function updateGenesysPosition() {
    var launcherFrame = document.querySelector('.genesys-mxg-launcher-frame');
    var conversation = document.querySelector('.genesys-mxg-conversation');

    var isVisible = isStickyBarVisible();
    var mobile = isMobile();

    if (launcherFrame) {
      if (mobile) {
        // Mobile: usa valori specifici per mobile
        launcherFrame.style.setProperty('bottom', (isVisible ? LAUNCHER_MOBILE_STICKY : LAUNCHER_MOBILE_DEFAULT) + 'px', 'important');
      } else {
        // Desktop
        launcherFrame.style.setProperty('bottom', (isVisible ? LAUNCHER_STICKY : LAUNCHER_DEFAULT) + 'px', 'important');
      }
    }

    if (conversation) {
      if (mobile) {
        // Mobile: sempre bottom 0 per non uscire dalla viewport
        conversation.style.setProperty('bottom', CONVERSATION_MOBILE + 'px', 'important');
      } else {
        // Desktop: comportamento normale
        conversation.style.setProperty('bottom', (isVisible ? CONVERSATION_STICKY : CONVERSATION_DEFAULT) + 'px', 'important');
      }
    }
  }

  function updateOneTrustConsentBtnPosition() {
    var otButton = document.getElementById('ot-sdk-btn-floating');
    if (!otButton) return;

    var isVisible = isStickyBarVisible();
    var mobile = isMobile();

    if (mobile) {
      otButton.style.setProperty('bottom', (isVisible ? LAUNCHER_MOBILE_STICKY : LAUNCHER_MOBILE_DEFAULT) + ONETRUST_BTN_BOTTOM_OFFSET + 'px', 'important');
    } else {
      otButton.style.setProperty('bottom', (isVisible ? LAUNCHER_STICKY : LAUNCHER_DEFAULT) + ONETRUST_BTN_BOTTOM_OFFSET + 'px', 'important');
    }
  }

  function updateAllPositions() {
    updateGenesysPosition();
    updateOneTrustConsentBtnPosition();
  }

  var observer = new MutationObserver(updateAllPositions);

  function initObserver() {
    var stickyBar = getStickyBar();
    if (stickyBar) {
      observer.observe(stickyBar, { attributes: true, attributeFilter: ['class', 'style'] });
    }

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    updateAllPositions();
  }

  window.addEventListener('resize', updateAllPositions);

  setInterval(updateAllPositions, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();